var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[(_vm.error.show)?_c('v-layout',[_c('PoweredByHeader'),_c('v-flex',{attrs:{"xs-12":""}},[_c('Error',{attrs:{"showError":_vm.error.show}},[_vm._v(" "+_vm._s(_vm.error.message)+" ")])],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }